
import React, { useCallback, useMemo } from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material//KeyboardArrowLeft';
import SendIcon from '@mui/icons-material//Send';
import { AppBar, Button, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material';
import { isEmpty } from 'lodash';
import { InformationRequestModalAppBarProps } from './InformationRequestModalAppBar.props';
import { classes, StyledAppBar } from './InformationRequestModalAppBar.styles';


const InformationRequestModalAppBar = ({
  responsibleUserId,
  questions,
  files,
  handleClose,
  setIsSavingModelOpen,
  hasCurrentInformationRequests,
  isSaving,
}: InformationRequestModalAppBarProps) => {
  const isButtonDisabled = useMemo(
    () => !responsibleUserId || (isEmpty(questions) && isEmpty(files)) || isSaving,
    [responsibleUserId, questions, files, isSaving]
  );

  const handleButtonClick = useCallback(() => {
    setIsSavingModelOpen(true);
  }, [setIsSavingModelOpen]);

  return (
    <StyledAppBar color="transparent" className={classes.appBar}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
          <KeyboardArrowLeftIcon />
        </IconButton>
        <Typography variant="h6" className={classes.title}>
          Information Request
        </Typography>
        <Tooltip
          title={
            isButtonDisabled
              ? 'Please select a responsible user and ensure there are documents or questions to send.'
              : ''
          }>
          <span>
            <Button
              autoFocus
              variant="contained"
              color="secondary"
              endIcon={<SendIcon />}
              onClick={handleButtonClick}
              disabled={isButtonDisabled}>
              {hasCurrentInformationRequests ? 'Update' : 'Send'}
            </Button>
          </span>
        </Tooltip>
      </Toolbar>
    </StyledAppBar>
  );
};

export default React.memo(InformationRequestModalAppBar);
